var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useLayoutEffect, useState } from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import { throttle } from "throttle-debounce";
import "./styles.scss";
var ScrollArea = function (_a) {
    var _b;
    var autoFitToContainer = _a.autoFitToContainer, height = _a.height, children = _a.children, hideScrollbar = _a.hideScrollbar;
    var initialClientWidth = (_b = autoFitToContainer === null || autoFitToContainer === void 0 ? void 0 : autoFitToContainer.current) === null || _b === void 0 ? void 0 : _b.clientWidth;
    var _c = __read(useState("auto"), 2), width = _c[0], setWidth = _c[1];
    var onResize = useCallback(function () {
        var _a;
        if (!initialClientWidth)
            return;
        var containerWidth = (_a = autoFitToContainer === null || autoFitToContainer === void 0 ? void 0 : autoFitToContainer.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        setWidth(containerWidth ? "".concat(containerWidth, "px") : "auto");
    }, [autoFitToContainer, initialClientWidth]);
    useLayoutEffect(function () {
        onResize();
        var resizeHandler = throttle(100, onResize);
        window.addEventListener("resize", resizeHandler);
        return function () { return window.removeEventListener("resize", resizeHandler); };
    }, [onResize]);
    return (_jsxs(ScrollAreaPrimitive.Root, { className: "scroll-area", children: [_jsx(ScrollAreaPrimitive.Viewport, { className: "scroll-area__viewport", style: __assign({ width: "".concat(width) }, (height && { maxHeight: "".concat(height, "px") })), children: children }), !hideScrollbar && (_jsxs(_Fragment, { children: [_jsx(ScrollAreaPrimitive.Scrollbar, { className: "scroll-area__scrollbar", orientation: "vertical", children: _jsx(ScrollAreaPrimitive.Thumb, { className: "scroll-area__thumb" }) }), _jsx(ScrollAreaPrimitive.Scrollbar, { className: "scroll-area__scrollbar", orientation: "horizontal", children: _jsx(ScrollAreaPrimitive.Thumb, { className: "scroll-area__thumb" }) }), _jsx(ScrollAreaPrimitive.Corner, { className: "scroll-area__corner" })] }))] }));
};
export { ScrollArea };
